export const TABLE_COLUMNS_NAMES = [
	{ dataIndex: 'id', title: '#', width: '125px', align: 'left' },
	{ dataIndex: 'text', title: 'Название', width: '315px' },
	{ dataIndex: 'count', title: 'Кол. компаний' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
